const routes = [
  {
    path: 'debounce',
    name: 'debounce',
    component: () => import(/* webpackChunkName: "debounce" */ '@/modules/debounce/index.vue')
  },
  {
    path: 'debouncecode',
    name: 'debouncecode',
    component: () => import(/* webpackChunkName: "debouncecode" */ '@/modules/debounce/code.vue')
  },
];

export default routes;